import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, b as _extends, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border:", " solid ", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.input.input.borders.width;
}, function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return theme.components.input.input.colors[variant].border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.input.input.borders.radius;
});
var colors = css(["color:", ";caret-color:", ";"], function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.components.input.input.colors[variant].text;
}, function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return theme.components.input.input.colors[variant].caret;
});
var sizes = css(["height:", ";width:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.input.input.sizes.height;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.input.input.sizes.width;
});
var spaces = css(["padding:", " ", " ", " ", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.input.input.spaces.paddingHeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.input.input.spaces.paddingWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.input.input.spaces.paddingHeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.components.input.input.spaces.paddingWidth;
});
var StyledInput = styled(Text.withComponent('input'))(_templateObject(), borders, colors, sizes, spaces, function (_ref12) {
  var theme = _ref12.theme,
      variant = _ref12.variant;
  return theme.components.input.input.colors[variant].placeholder;
}, function (_ref13) {
  var theme = _ref13.theme,
      variant = _ref13.variant;
  return theme.components.input.input.colors[variant].borderFocus;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.components.input.input.boxShadows.boxShadowFocus;
});
StyledInput.defaultProps = {
  variant: 'normal'
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * An input field.
 *
 */

var Input = function Input(_ref) {
  var id = _ref.id,
      form = _ref.form,
      name = _ref.name,
      onChange = _ref.onChange,
      forwardedRef = _ref.forwardedRef,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      size = _ref.size,
      type = _ref.type,
      value = _ref.value,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["id", "form", "name", "onChange", "forwardedRef", "pattern", "placeholder", "size", "type", "value", "variant"]);

  return React.createElement(StyledInput, _extends({
    form: form,
    id: id,
    name: name,
    onChange: onChange,
    pattern: pattern,
    placeholder: placeholder,
    size: size,
    type: type,
    value: value,
    ref: forwardedRef,
    variant: variant
  }, rest));
};

Input.defaultProps = {
  form: undefined,
  forwardedRef: undefined,
  id: undefined,
  name: '',
  onChange: undefined,
  pattern: undefined,
  placeholder: '',
  size: null,
  type: 'text',
  value: undefined,
  variant: 'normal'
};
Input.propTypes = {
  /**
   * The id of the input field.
   */
  id: PropTypes.string,

  /**
   * One or more forms the Input element belongs to.
   */
  form: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Name of the input element.
   */
  name: PropTypes.string,

  /**
   * Gets called when the user clicks on the link.
   *
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onChange: PropTypes.func,

  /**
   * Ref of the input element.
   */
  forwardedRef: PropTypes.func,

  /**
   * Specifies a regular expression that an Input elemen'ts value is checked against.
   */
  pattern: PropTypes.string,

  /**
   * A short hint that describes the expected value of an Input element.
   */
  placeholder: PropTypes.string,

  /**
   * The width, in characters, of an input element.
   */
  size: PropTypes.number,

  /**
   * The type of the input field.
   */
  type: PropTypes.string,

  /**
   * The value of the input element.
   */
  value: PropTypes.any,

  /**
   * Which type of input to display.
   */
  variant: PropTypes.oneOf(['normal', 'error', 'warning'])
};
/** @component */

var Input$1 = styled(React.forwardRef(function (props, ref) {
  return React.createElement(Input, _extends({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject$1());

export default Input$1;
